import cookies from 'js-cookie'

export const usesNest = (url: string) => {
  const cookieSet = cookies.get('sa_nest')
  // TODO: implement whitelist
  return cookieSet && url.includes('organisations')
}
